import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgProfile = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 9.6674C11.9125 9.6674 13.4615 8.17573 13.4615 6.33407C13.4615 4.4924 11.9125 3.00073 10 3.00073C8.0875 3.00073 6.53846 4.4924 6.53846 6.33407C6.53846 8.17573 8.0875 9.6674 10 9.6674ZM9.14327 11.223C6.30192 11.223 4 13.4396 4 16.1757C4 16.6313 4.38365 17.0007 4.85673 17.0007H15.1433C15.6163 17.0007 16 16.6313 16 16.1757C16 13.4396 13.6981 11.223 10.8567 11.223H9.14327Z",
		fill: "#0D2976"
	})
});
export default SvgProfile;
